export { default as Cssify } from './cssify';
export { default as CreateCss } from './utils/create-declaration-block';
//# sourceMappingURL=index.js.map